import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { TmBaseComponent } from '../tm-base.component';

export const tagName = 'tm-loader';
@customElement(tagName)
export class TmLoader extends TmBaseComponent {
    @property({ type: Boolean })
    public card = false;

    @property({ type: Boolean })
    public inline = false;

    @property({ type: Boolean })
    public small = false;

    @property({ type: Boolean })
    public reversed = false;

    protected render() {
        return html`<div
            class=${classMap({
                'rounded-full border-r-transparent animate-spin origin-center': true,
                'w-4 h-4': !this.card && !this.inline && !this.small,
                'w-7 h-7': this.card,
                'w-3 h-3': this.inline,
                'w-2 h-2': this.small,
                'border-2': !this.card,
                'border-4 my-20 mx-auto': this.card,
                'border-[--default]': !this.reversed,
                'border-[--reversed]': this.reversed,
            })}
        ></div>`;
    }

    public static get styles() {
        return css`
            :host {
                --default: var(--tm-color-gray-medium-30);
                --reversed: var(--jh-color-gray-0);
            }
            :host([theme='dark']) {
                --default: var(--tm-color-gray-light);
                --reversed: var(--jh-color-gray-100);
            }
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: TmLoader;
    }
}
